import API from '../../../../../services/api';

export const API_WHATSAPP = {
    enviarWhatsAppRecordatorio: async (recordatorio) => {
        return API.post('whatsapp/recordatorio', recordatorio).then(res => res.data);
    },
    enviarWhatsAppsRecordatorios: async (recordatorios) => {
        return API.post('whatsapp/recordatorios', recordatorios).then(res => res.data);
    }
}